/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionLeadAdmissionStatusInfo } from './PalAuthSubmissionLeadAdmissionStatusInfo';
import {
    PalAuthSubmissionLeadAdmissionStatusInfoFromJSON,
    PalAuthSubmissionLeadAdmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionLeadAdmissionStatusInfoToJSON,
    PalAuthSubmissionLeadAdmissionStatusInfoToJSONTyped,
} from './PalAuthSubmissionLeadAdmissionStatusInfo';
import type { PalAuthSubmissionLeadScreenerLeadInfoRace } from './PalAuthSubmissionLeadScreenerLeadInfoRace';
import {
    PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSON,
    PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSONTyped,
    PalAuthSubmissionLeadScreenerLeadInfoRaceToJSON,
    PalAuthSubmissionLeadScreenerLeadInfoRaceToJSONTyped,
} from './PalAuthSubmissionLeadScreenerLeadInfoRace';
import type { CarveOutTrackingListEntryLeadAllOfAssignmentsInner } from './CarveOutTrackingListEntryLeadAllOfAssignmentsInner';
import {
    CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSON,
    CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSONTyped,
    CarveOutTrackingListEntryLeadAllOfAssignmentsInnerToJSON,
    CarveOutTrackingListEntryLeadAllOfAssignmentsInnerToJSONTyped,
} from './CarveOutTrackingListEntryLeadAllOfAssignmentsInner';
import type { PalReauthSubmissionListEntryLeadExternalEhrPatient } from './PalReauthSubmissionListEntryLeadExternalEhrPatient';
import {
    PalReauthSubmissionListEntryLeadExternalEhrPatientFromJSON,
    PalReauthSubmissionListEntryLeadExternalEhrPatientFromJSONTyped,
    PalReauthSubmissionListEntryLeadExternalEhrPatientToJSON,
    PalReauthSubmissionListEntryLeadExternalEhrPatientToJSONTyped,
} from './PalReauthSubmissionListEntryLeadExternalEhrPatient';

/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntryLead
 */
export interface PalReauthSubmissionListEntryLead {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    admission_status?: string | null;
    /**
     * 
     */
    admission_status_info?: PalAuthSubmissionLeadAdmissionStatusInfo;
    /**
     * 
     */
    facility?: PalAuthSubmissionLeadScreenerLeadInfoRace;
    /**
     * Lead assignments (owner and liaisons)
     */
    assignments?: Array<CarveOutTrackingListEntryLeadAllOfAssignmentsInner>;
    /**
     * 
     */
    external_ehr_patient?: PalReauthSubmissionListEntryLeadExternalEhrPatient;
}

/**
 * Check if a given object implements the PalReauthSubmissionListEntryLead interface.
 */
export function instanceOfPalReauthSubmissionListEntryLead(value: object): value is PalReauthSubmissionListEntryLead {
    return true;
}

export function PalReauthSubmissionListEntryLeadFromJSON(json: any): PalReauthSubmissionListEntryLead {
    return PalReauthSubmissionListEntryLeadFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntryLead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'admission_status': json['admission_status'] === undefined ? undefined : json['admission_status'] === null ? null : json['admission_status'],
        'admission_status_info': json['admission_status_info'] == null ? undefined : PalAuthSubmissionLeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'facility': json['facility'] == null ? undefined : PalAuthSubmissionLeadScreenerLeadInfoRaceFromJSON(json['facility']),
        'assignments': json['assignments'] == null ? undefined : ((json['assignments'] as Array<any>).map(CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSON)),
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : PalReauthSubmissionListEntryLeadExternalEhrPatientFromJSON(json['external_ehr_patient']),
    };
}

export function PalReauthSubmissionListEntryLeadToJSON(json: any): PalReauthSubmissionListEntryLead {
    return PalReauthSubmissionListEntryLeadToJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryLeadToJSONTyped(value?: PalReauthSubmissionListEntryLead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'admission_status': value['admission_status'],
        'admission_status_info': PalAuthSubmissionLeadAdmissionStatusInfoToJSON(value['admission_status_info']),
        'facility': PalAuthSubmissionLeadScreenerLeadInfoRaceToJSON(value['facility']),
        'assignments': value['assignments'] == null ? undefined : ((value['assignments'] as Array<any>).map(CarveOutTrackingListEntryLeadAllOfAssignmentsInnerToJSON)),
        'external_ehr_patient': PalReauthSubmissionListEntryLeadExternalEhrPatientToJSON(value['external_ehr_patient']),
    };
}

